"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var PluginTypes;
(function (PluginTypes) {
    PluginTypes["Giphy"] = "wix-draft-plugin-giphy";
    PluginTypes["Image"] = "wix-draft-plugin-image";
    PluginTypes["Poll"] = "wix-draft-plugin-poll";
    PluginTypes["Gallery"] = "wix-draft-plugin-gallery";
    PluginTypes["FileUpload"] = "wix-draft-plugin-file-upload";
    PluginTypes["Video"] = "wix-draft-plugin-video";
    PluginTypes["ExternalMentions"] = "wix-draft-plugin-external-mentions";
    PluginTypes["Mention"] = "mention";
    PluginTypes["LinkPreview"] = "wix-draft-plugin-link-preview";
})(PluginTypes = exports.PluginTypes || (exports.PluginTypes = {}));
//# sourceMappingURL=pluginTypes.js.map